import user from "../../../enums/user";

/*=========================================================================================
  File Name: moduleKindsMutations.js
  Description: Kinds Module Mutations
  ----------------------------------------------------------------------------------------
==========================================================================================*/
export default {
  SET_KINDS (state, kinds) {
    state.kinds = kinds
  },
  SET_INFO_DB(state, payload){
    state.infoDB = payload
  },
  UPDATE_KINDS(state, payload){
    const index = state.kinds.findIndex(user => user.id == payload.id);
    state.kinds.splice(index, 1)
    state.kinds.splice(index, 0, payload)
  }
}